<template>
  <div>
    <gmap-map
      :center="centers"
      :zoom="11"
      map-type-id="terrain"
      style="width: 100%; height: 340px"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
      ></gmap-marker>
      <GmapCircle
        :key="index"
        v-for="(m, index) in markers"
        :center="m.position"
        :radius="4000"
        :options="{
          strokeColor: '#057de7', //线颜色
          strokeOpacity: 0.2, //线透明度
          strokeWeight: 2, //线粗细度
          fillColor: '#1791fc' //填充颜色
        }"
      />
      <!-- @click="centers=m.position" -->
    </gmap-map>
    <van-button @click="reverseGeocode">test</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      centers: { lat: 39.90419989999999, lng: 116.4073963 },
      markers: [
        {
          position: { lat: 39.90419989999999, lng: 116.4073963 }
        }
      ],
      address: ''
    }
  },
  description: 'Autocomplete Example (#164)',
  mounted() {
    // this.reverseGeocode()
  },
  methods: {
    reverseGeocode() {
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ location: this.centers }, (results, status) => {
        if (status === 'OK') {
          console.log(results, 'new google.maps.Geocoder results')

          if (results[0]) {
            this.address = results[0].formatted_address
          } else {
            this.address = 'No results found'
          }
        } else {
          this.address = `Geocoder failed due to: ${status}`
        }
      })
    }
  }
}
</script>
